import { createAction, props } from '@ngrx/store';
import {Clip, ClipStatus} from '../../../services/api/clips/clip.model';
import {UUID} from '../../../shared/types/uuid.type';

export const loadClips = createAction(
  '[Clips] Load Clips'
);

export const loadClipsSuccess = createAction(
  '[Clips] Load Clips Success',
  props<{ data: Clip[] }>()
);

export const loadClipsFailure = createAction(
  '[Clips] Load Clips Failure',
  props<{ error: any }>()
);

export const clipUpdated = createAction(
  '[Clips] Clip Updated',
  props<{ data: Clip }>()
);

export const clipStatusUpdated = createAction(
  '[Clips] Clip Status Updated',
  props<{ id: UUID, status: ClipStatus }>()
);

export const manyClipsDeleted = createAction(
  '[Clips] Many Clips Deleted',
  props<{ ids: UUID[] }>()
);

export const clearClipsState = createAction(
  '[Clips] clear Clips State',
);
